<htx-button variant="tertiary" icon="arrow_back" (click)="goBack()">
  {{ 'button.back' | transloco }}
</htx-button>

<article class="terms-container" *transloco="let t; prefix: 'terms'">
  <h1 class="terms-title">{{ t('title') }}</h1>
  <p class="terms-subtitle">Anhang 2: Allgemeine Geschäftsbedingungen (HT-X) — Version 1.0, Juni 2025</p>

  <section class="terms-section">
    <h2 class="terms-h2">1. Anwendbarkeit, Umfang und Governance</h2>
    <p class="terms-clause">
      <span class="terms-no">1.1</span>Der Datenraum wird durch den Gründungsvertrag errichtet, der von den
      Gründungsmitgliedern des Datenraums unterzeichnet wird.
    </p>
    <p class="terms-clause">
      <span class="terms-no">1.2</span>Die Bestimmungen dieser Allgemeinen Geschäftsbedingungen gelten und sind
      rechtlich verbindlich für die Verträge zur gemeinsamen Datennutzung der Parteien des Datenraums bei der
      Unterzeichnung des Gründungsvertrags und der Beitrittsvereinbarungen sowie für Teilnehmer, die keine
      Mitglieder des Datenraums sind.
    </p>
    <p class="terms-clause">
      <span class="terms-no">1.3</span>Wenn es Widersprüche zwischen den Bedingungen des Gründungsvertrags, einer
      Beitrittsvereinbarung und diesen Allgemeinen Geschäftsbedingungen, einschließlich ihrer Anhänge oder
      Anlagen gibt, wird ein solcher Widerspruch gemäß der folgenden Reihenfolge gelöst:
    </p>
    <ol class="terms-list">
      <li>die Klauseln des Gründungsvertrages;</li>
      <li>die Klauseln der Beitrittsvereinbarung(en);</li>
      <li>die Nutzungsbedingungen für Datensätze und damit verbundene Anlagen;</li>
      <li>diese Allgemeinen Geschäftsbedingungen; und</li>
      <li>sonstige Anhänge zum Gründungsvertrag in nummerischer Reihenfolge.</li>
    </ol>
    <p class="terms-clause">
      <span class="terms-no">1.4</span>Sämtliche Änderungen oder Abweichungen von diesen Allgemeinen
      Geschäftsbedingungen müssen im Gründungsvertrag vereinbart werden, damit sie gültig sind.
    </p>
  </section>

  <section class="terms-section">
    <h2 class="terms-h2">2. Definitionen</h2>
    <p class="terms-clause">
      <span class="terms-no">2.1</span>In diesen Allgemeinen Geschäftsbedingungen haben folgende dick gedruckten
      Begriffe die nachfolgenden Bedeutungen, und der Singular schließt (gegebenenfalls) den Plural ein und
      umgekehrt (die Reihenfolge der Nennung entspricht dem Original in englischer Sprache):
    </p>
    <p>
      <strong>„Abgeleitetes Material"</strong> bezeichnet Informationen, die von Daten oder Informationen
      abgeleitet sind, die als Ergebnis der Kombination, Veredelung und/oder Verarbeitung der Daten mit anderen
      Daten entstanden sind. Falls es einen Bedarf gibt, die Grenze zwischen Daten und abgeleitetem Material zu
      klären, sind zusätzliche Anforderungen dafür, was nicht als abgeleitetes Material gilt, in den jeweiligen
      Nutzungsbedingungen für Datensätze festzulegen.
    </p>
    <p><strong>„Anhang"</strong> bezeichnet einen Anhang zum Gründungsvertrag.</p>
    <p><strong>„Anlage"</strong> bezeichnet eine Anlage zu den Nutzungsbedingungen für Datensätze.</p>
    <p>
      <strong>„Beitrittsvereinbarung"</strong> bezeichnet die Vereinbarung, der der Beitritt von Parteien zum
      Gründungsvertrag und dem Datenraum nach der Unterzeichnung des Gründungsvertrags unterliegt.
    </p>
    <p><strong>„Berechtigung"</strong> ist jedes Recht auf die Verarbeitung von Daten.</p>
    <p>
      <strong>„Berechtigungsmanagement"</strong> bedeutet die Verwaltung aller Arten von rechtlich relevanten
      Berechtigungen zur Nutzung von Daten.
    </p>
    <p>
      <strong>„Betreiber"</strong> bezeichnet eine Partei, die Datensysteme- oder andere Infrastrukturservices
      für den Datenraum bereitstellt, die beispielsweise mit dem Identitäts- oder Einwilligungsmanagement, dem
      Protokollierungs- oder Servicemanagement verbunden sind.
    </p>
    <p>
      <strong>„Betreiber-Dienstleistungsvereinbarung"</strong> bezeichnet Service Level Agreements, die die
      Services regeln, die von einem Betreiber dem Datenraum oder seinen Mitgliedern erbracht werden.
    </p>
    <p>
      <strong>„Gründungsvertrag"</strong> bezeichnet den Vertrag, gemäß dem der Datenraum errichtet wird, und
      alle seine Anhänge.
    </p>
    <p>
      <strong>„Daten"</strong> bezeichnet jede digitale Darstellung von Handlungen, Tatsachen oder Informationen
      sowie jede Zusammenstellung solcher Handlungen, Tatsachen oder Informationen auch in Form von Ton-, Bild-
      oder audiovisuellem Material, die die Datenanbieter verbreiten, übertragen, weitergegeben oder ansonsten
      dem Datenraum zur Verfügung gestellt haben, und zwar auf der Grundlage des Gründungsvertrags und während
      seiner Laufzeit, wie sie weiter in den Nutzungsbedingungen für Datensätze definiert sind.
    </p>
    <p>
      <strong>„Datenanbieter"</strong> ist ein Datenraumteilnehmer, der im Rahmen einer bestimmten
      Datentransaktion den Datennutzern, die das Recht oder die Pflicht haben, auf diese Daten zuzugreifen
      und/oder sie zu erhalten, Daten technisch zur Verfügung stellt.
    </p>
    <p>
      <strong>„Datennutzer"</strong> ist eine der Parteien, denen die Diensteanbieter Daten und/oder Dienste zur
      Verfügung stellen oder denen ein Datenanbieter Daten zur Verfügung stellt, und die die Daten nicht
      weiterbreitet.
    </p>
    <p>
      <strong>„Datenraum"</strong> bezeichnet die Gruppe, die aus den Parteien besteht, die Daten gemäß dem
      Gründungsvertrag austauschen.
    </p>
    <p>
      <strong>„Datensatz"</strong> bezeichnet eine Sammlung von Daten, deren Nutzung der Datenanbieter über den
      Datenraum autorisiert. Datensätze und die damit verbundenen Bedingungen werden in den jeweiligen
      Dataset-Nutzungsbedingungen ausführlicher definiert.
    </p>
    <p>
      <strong>„Datenverarbeiter"</strong> hat die gleiche Bedeutung wie in Art 4 Abs 8 der
      Datenschutzgrundverordnung (DSGVO) (Verordnung (EU) 2016/679) definiert. Er bezieht sich auf jede Person,
      die personenbezogene Daten im Auftrag des für die Verarbeitung Verantwortlichen verarbeitet.
    </p>
    <p>
      <strong>„Dienstleister"</strong> bezeichnet eine der Parteien, die Daten kombinieren, aufbereitet und
      verarbeiten und die verarbeiteten Daten und/oder einen Service, der auf den Daten basiert, zur Nutzung
      durch Datennutzer, andere Dienstleister oder Drittpartei-Datennutzer bereitstellen.
    </p>
    <p><strong>„Drittpartei"</strong> bezeichnet andere Parteien als eine Partei des Datenraums.</p>
    <p>
      <strong>„Drittpartei-Datennutzer"</strong> bezeichnet jede Drittpartei, die Daten direkt oder indirekt von
      einem Dienstleister erhält.
    </p>
    <p>
      <strong>„Governance-Modell"</strong> bezeichnet einen Anhang zum Gründungsvertrag, der eine
      datenraumspezifische Beschreibung der Regeln und Verfahren des Beitritts (d.h. wer wird zum Datenraum
      zugelassen und wie), geltende Entscheidungsfindungsmechanismen und weitere Governancebestimmungen über die
      Verwaltung des Datenraums einschließt.
    </p>
    <p>
      <strong>„Gründungsmitglieder"</strong> sind die anfänglichen Parteien, die den Gründungsvertrag
      abschließen.
    </p>
    <p>
      <strong>„Immaterialgüterrechte"</strong> bezeichnet Patente, Markenrechte, Handels- und Geschäftsnamen,
      Designrechte, Gebrauchsmuster, Urheberrechte (einschließlich Urheberrechte an Computersoftware) und
      Datenbankrechte, in jedem Fall sowohl eingetragene als auch nicht eingetragene und einschließlich aller
      ähnlichen Rechte auf jegliche dieser Rechte in jeder Jurisdiktion und alle anhängigen Anträge oder Rechte
      die Eintragung eines dieser Rechte zu beantragen.
    </p>
    <p>
      <strong>„Inhaber der Datenrechte"</strong> meint eine Entität (eine natürliche oder eine juristische
      Person), die Rechte und/oder Pflichten hat, Zugang zu bestimmten personenbezogenen oder nicht
      personenbezogenen Daten zu gewähren oder diese weiterzugeben.
    </p>
    <p>
      <strong>„Liste der Mitglieder"</strong> bezeichnet eine Liste mit Parteien, die im Gründungsvertrag näher
      beschreiben ist und die mit dem Beitritt neuer Parteien und der Kündigung bestehender Parteien aktualisiert
      wird.
    </p>
    <p>
      <strong>„Mitglied" oder „Partei"</strong> bezeichnet eine Partei des Gründungsvertrags und/oder einer
      Beitrittsvereinbarung.
    </p>
    <p>
      <strong>„Nutzungsbedingungen für Datensätze"</strong>: die Bedingungen, unter denen der Datenanbieter den
      Diensteanbietern und/oder Datennutzern ein Recht zur Nutzung der im Dataset enthaltenen Daten gewährt.
    </p>
    <p>
      <strong>„Personenbezogene Daten"</strong> hat die Bedeutung wie in der Verordnung (EU) 2016/679 des
      Europäischen Parlament und des Rates vom 27. April 2016 zum Schutz natürlicher Personen bei der
      Verarbeitung personenbezogener Daten, zum freien Datenverkehr und zur Aufhebung der Richtlinie 95/46/EG
      (Datenschutz-Grundverordnung) („DSGVO").
    </p>
    <p>
      <strong>„Verantwortlicher"</strong> hat dieselbe Bedeutung wie in Artikel 4 Abs 7 der
      Datenschutzgrundverordnung (DSGVO) (Verordnung (EU) 2016/679) definiert. Er bezieht sich auf jede Person,
      die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung personenbezogener Daten
      entscheidet.
    </p>
    <p>
      <strong>„Verbundenes Unternehmen"</strong> bezeichnet eine Person, Unternehmen, Gesellschaft, Partnerschaft
      oder sonstige Einheit, die die Partei direkt oder indirekt kontrolliert, von ihr kontrolliert wird oder
      sich unter gemeinsamer Kontrolle mit der Partei befindet.
    </p>
    <p>
      <strong>„Vereinbarung zur Datenverarbeitung"</strong> bezeichnet einen schriftlichen Vertrag, der zwischen
      einem Verantwortlichen und einem Verarbeiter abgeschlossen wird, der personenbezogene Daten im Auftrag des
      Verantwortlichen verarbeitet. In dieser Vereinbarung werden das Objekt und die Dauer der Verarbeitung, die
      Art und der Zweck der Verarbeitung, der Typ der personenbezogenen Daten und die Kategorien von Betroffenen
      sowie die Rechte und Pflichten des Verantwortlichen festgelegt.
    </p>
    <p>
      <strong>„Vertrauliche Informationen"</strong> bezieht sich auf Geschäftsgeheimnisse im Sinne der
      EU-Richtlinie 2016/943 vom 8. Juni 2016 über den Schutz vertraulichen Know-hows und vertraulicher
      Geschäftsinformationen (Geschäftsgeheimnisse) vor rechtswidrigem Erwerb sowie rechtswidriger Nutzung und
      Offenlegung Art 1, Z 2 vorausgesetzt, dass sie: (a) wenn sie schriftlich oder in einer anderen materiellen
      Form offengelegt werden, von der offenlegenden Partei zum Zeitpunkt der Offenlegung klar als vertraulich
      oder firmeneigen markiert werden, oder (b) wenn sie in immaterieller Form offengelegt werden, zum Zeitpunkt
      der Offenlegung als vertraulich identifiziert werden und sie der empfangenden Partei schriftlich innerhalb
      von vierzehn (14) Kalendertagen nach der Offenlegung von der offenlegenden Partei als vertrauliche
      Informationen bestätigt werden.
    </p>
  </section>

  <section class="terms-section">
    <h2 class="terms-h2">3. Rollenspezifische Verantwortlichkeiten</h2>
    <p class="terms-clause">
      <span class="terms-no">3.1</span>Die potenziellen Rollen, die im Rahmen dieser Allgemeinen
      Geschäftsbedingungen für die Parteien des Gründungsvertrags definiert werden, sind (1) der Datenanbieter,
      (2) der Dienstleister, (3) der Datennutzer und (4) der Betreiber. Eine Partei kann gleichzeitig mehrere
      Rollen innehaben. In einem solchen Fall muss die Partei alle geltenden Verpflichtungen im Zusammenhang mit
      jeder Rolle und den relevanten Daten einhalten. Zusätzlich ist der Drittpartei-Datennutzer eine Rolle, die
      gemäß diesen Allgemeinen Geschäftsbedingungen für alle Stakeholder gilt, die nicht eine Partei des
      Gründungsvertrags sind, die aber Daten erhalten.
    </p>
    <p class="terms-clause">
      <span class="terms-no">3.2</span>Eine genauere Festlegung der rollenspezifischen Verantwortlichkeiten kann
      im Gründungsvertrag aufgenommen werden.
    </p>

    <h3 class="terms-h3">Datenanbieter</h3>
    <p class="terms-clause">
      <span class="terms-no">3.3</span>Der Datenanbieter ist für die Definition der Nutzungsbedingungen für
      Datensätze für alle Daten verantwortlich, die der Datenanbieter im Datenraum zur Verfügung stellt. Dies
      schließt das Recht zur Definition der Zwecke ein, zu denen relevante Daten verarbeitet werden können, das
      Recht, die Weiterverbreitung der Daten an Datennutzer zu erlauben, und gegebenenfalls an
      Drittpartei-Datennutzer, und das Recht, die unbefugte Nutzung der Daten zu verbieten, sowie das Recht, die
      gemeinsame Datennutzung im Datenraum einzustellen. Der Datenanbieter muss sicherstellen, dass ein
      angemessenes Berechtigungsmanagement vorhanden ist, damit die Datenrechtsinhaber im Rahmen der geltenden
      Gesetze die Kontrolle über ihre Daten behalten und die Datennutzer die erforderlichen Berechtigungen
      erhalten können. Der Datenanbieter muss die Parteien, denen er den Datensatz zur Verfügung stellt, über
      alle neue Nutzungsbedingungen für Datensätze unterrichten, woraufhin die Nutzungsbedingungen für Datensätze
      für die anderen Parteien verbindlich sind. Wenn in den geltenden Nutzungsbedingungen für Datensätze nicht
      anderes definiert wird, treten alle Änderungen, die der Datenanbieter an den geltenden Nutzungsbedingungen
      für Datensätze vornimmt, innerhalb von dreißig (30) Tagen in Kraft, an dem den relevanten Parteien des
      Datenraums die Mitteilung einer solchen Änderung zugestellt wird. Änderungen der Nutzungsbedingungen für
      Datensätze dürfen nicht rückwirkend gelten.
    </p>
    <p class="terms-clause">
      <span class="terms-no">3.4</span>Der Datenanbieter hat Daten für die Nutzung im Datenraum in
      maschinenlesbarer Form und mittels einer vom Datenanbieter festgelegten Methode gemäß den geltenden
      Nutzungsbedingungen für Datensätze zur Verfügung zu stellen (z. B. über eine Programmierschnittstelle
      (API), ein herunterladbares Paket oder eine andere Methode).
    </p>
    <p class="terms-clause">
      <span class="terms-no">3.5</span>Abweichend von Klausel 3.3 kann sich der Datenanbieter verpflichten, das
      Recht zur Nutzung bestimmter Datensätze oder Datentypen dem Datenraum für einen festgelegten Zeitraum
      einzuräumen, um Investitionen anderer Parteien in den Datenraum, die in gutem Glauben getätigt wurden, zu
      schützen.
    </p>

    <h3 class="terms-h3">Dienstleister</h3>
    <p class="terms-clause">
      <span class="terms-no">3.6</span>Der Dienstleister ist für die Verarbeitung von Daten gemäß dem
      Gründungsvertrag und den geltenden Nutzungsbedingungen für Datensätze verantwortlich.
    </p>
    <p class="terms-clause">
      <span class="terms-no">3.7</span>Der Dienstleister hat Aufzeichnungen über seine Verarbeitungstätigkeiten zu
      führen und auf Anfrage angemessen detaillierte Berichte über die Nutzung, Verarbeitung und
      Weiterverbreitung von Daten an die jeweiligen Datenanbieter zu übermitteln.
    </p>

    <h3 class="terms-h3">Datennutzer</h3>
    <p class="terms-clause">
      <span class="terms-no">3.8</span>Der Datennutzer hat die Daten im Einklang mit dem Gründungsvertrag und den
      geltenden Nutzungsbedingungen für Datensätze zu verwenden.
    </p>

    <h3 class="terms-h3">Teilnehmer</h3>
    <p class="terms-clause">
      <span class="terms-no">3.9</span>Teilnehmer sind kein Mitglied des Datenraums. Sie können sowohl Datennutzer
      als auch Datenanbieter sein. Für Teilnehmer gelten alle Bestimmungen dieser AGB sinngemäß, soweit nicht
      Abweichendes bestimmt wurde. Teilnehmer müssen bevor sie am Datenraum teilnehmen können eine
      Teilnahmeerklärung abgeben und sich dafür vom Betreiber akkreditieren lassen.
    </p>

    <h3 class="terms-h3">Betreiber</h3>
    <p class="terms-clause">
      <span class="terms-no">3.10</span>Der Datenraum kann einen oder mehrere Betreiber haben. Die Betreiber sind
      verantwortlich für die Bereitstellung von Dienstleistungen, die den Betrieb des Datenraums unterstützen,
      wie z. B. Authentifizierung, Identifikation sowie Identitäts- und Einwilligungsmanagement. Zudem können sie
      für die Sicherung der Daten oder die Bereitstellung technischer Datenschutzlösungen für den Datenraum
      zuständig sein, wie in der jeweils geltenden Betreiber-Dienstleistungsvereinbarung näher definiert.
    </p>
    <p class="terms-clause">
      <span class="terms-no">3.11</span>Jeder Dienstleistungsvertrag für Betreiber, der zwischen der Partei/den
      Parteien und dem/den Betreiber(n) abgeschlossen wird, kann als Anhang an den Gründungsvertrag angehängt
      werden.
    </p>
    <p class="terms-clause">
      <span class="terms-no">3.12</span>Der Betreiber hat alle regulatorischen Anforderungen einzuhalten,
      einschließlich der Meldepflichten, die durch die geltende Gesetzgebung vorgeschrieben sind.
    </p>
    <p class="terms-clause">
      <span class="terms-no">3.13</span>Sollte ein Betreiber oder ein anderer Teilnehmer die Definition eines
      Datenvermittlungsdienstleisters gemäß dem Data Governance Act (DGA) erfüllen, gelten die Anforderungen des
      Kapitel III des DGA.
    </p>
  </section>

  <section class="terms-section">
    <h2 class="terms-h2">4. Weiterverarbeitung von Daten</h2>
    <p class="terms-clause">
      <span class="terms-no">4.1</span>Die Parteien haben das Recht, die Daten an die anderen Parteien
      weiterzuverbreiten, es sei denn, dass eine solche Weiterverbreitung gemäß den geltenden Nutzungsbedingungen
      für Datensätze ausdrücklich verboten wurde. Parteien dürfen Daten an Drittpartei-Datennutzer nur
      weitergeben, wenn dies durch die geltenden Nutzungsbedingungen für Datensätze oder die anwendbaren Gesetze
      erlaubt ist.
    </p>
    <p class="terms-clause">
      <span class="terms-no">4.2</span>Wenn der Datenanbieter sich dafür entscheidet, eine Weiterverbreitung der
      Daten an Drittpartei-Datennutzer zuzulassen, ist der Datenanbieter dafür verantwortlich zu bestimmten,
      welche Nutzungsbedingungen für Datensätze für die Weiterverbreitung gelten. Ein Dienstleister muss solche
      Bedingungen in Bezug auf die Weiterverbreitung von Daten in alle Verträge oder Geschäftsbedingungen mit
      Drittpartei-Datennutzern aufnehmen.
    </p>
    <p class="terms-clause">
      <span class="terms-no">4.3</span>Ungeachtet des Vorstehenden haben die Parteien das Recht, die Daten an ihre
      verbundenen Unternehmen weiterzuverbreiten, es sei denn, die geltenden Nutzungsbedingungen für Datensätze
      verbieten eine solche Weiterverbreitung ausdrücklich. Jede Partei ist dafür verantwortlich sicherzustellen,
      dass ihre verbundenen Unternehmen den Gründungsvertrag einhalten.
    </p>

    <h3 class="terms-h3">Abgeleitetes Material und seine Weiterverbreitung</h3>
    <p class="terms-clause">
      <span class="terms-no">4.4</span>Die Rechte an abgeleitetem Material gehören der Partei, die dieses Material
      erzeugt, und die Nutzungsbeschränkungen, die für die Daten in den Nutzungsbedingungen für Datensätze
      festgelegt sind, gelten nicht für abgeleitetes Material. Einschränkungen für die Nutzung oder
      Weiterverbreitung von abgeleitetem Material müssen, sofern vorgesehen, ausdrücklich in den
      Nutzungsbedingungen für Datensätze festgelegt werden.
    </p>
    <p class="terms-clause">
      <span class="terms-no">4.5</span>Die Parteien sind berechtigt, abgeleitetes Material an die anderen Parteien
      und an Drittparteien weiterzuleiten, es sei denn, dass dies in den geltenden Nutzungsbedingungen für
      Datensätze ausdrücklich verboten ist.
    </p>

    <h3 class="terms-h3">Verarbeitung und Weiterverbreitung personenbezogener Daten</h3>
    <p class="terms-clause">
      <span class="terms-no">4.6</span>Die Weiterverbreitung von personenbezogenen Daten oder von abgeleitetem
      Material, das auf der Grundlage personenbezogener Daten erstellt wurde, kann detaillierteren Anforderungen
      und Einschränkungen unterliegen. Jeder Verantwortliche hat sicherzustellen, dass eine Weiterverbreitung und
      sonstige Nutzung abgeleiteter Materialien im Einklang mit der geltenden Datenschutzgesetzgebung erfolgt.
      Zusätzlich unterliegt jegliches Zusammenwirken zwischen Datenverantwortlichen und Auftragsverarbeitern den
      geltenden Datenverarbeitungsvereinbarungen. Die Parteien können außerdem gesondert detailliertere
      Bestimmungen zur Verarbeitung personenbezogener Daten als Teil der Nutzungsbedingungen für Datensätze
      vereinbaren.
    </p>
  </section>

  <section class="terms-section">
    <h2 class="terms-h2">5. Allgemeine Verantwortlichkeiten</h2>

    <h3 class="terms-h3">Datensicherheit, Datenschutz und Datenmanagement</h3>
    <p class="terms-clause">
      <span class="terms-no">5.1</span>Jede Partei muss eine Kontaktperson für Datensicherheitsangelegenheiten
      festlegen, die für die mit dem Datenraum verbundenen Datensysteme der Partei und für die Implementierung
      der Sicherheitsrichtlinie der Partei verantwortlich ist.
    </p>
    <p class="terms-clause">
      <span class="terms-no">5.2</span>Jede Partei des Datenraums muss ausreichende Fähigkeiten haben, um Daten
      sicher und gemäß den relevanten Datensicherheitsstandards und der Datenschutzgesetzgebung zu verarbeiten.
      Die Parteien müssen geeignete technische, organisatorische und physische Maßnahmen umsetzen und
      aufrechterhalten, die den bewährten Marktpraktiken entsprechen, wobei die Art der von der Partei
      verarbeiteten Daten zu berücksichtigen ist. Jede Partei muss in der Lage sein, ihre Verpflichtungen gemäß
      dem Gründungsvertrag und den geltenden Nutzungsbedingungen für Datensätze ordnungsgemäß zu erfüllen und,
      falls erforderlich aus berechtigten Gründen, Verarbeitungstätigkeiten unverzüglich einzustellen.
    </p>
    <p class="terms-clause">
      <span class="terms-no">5.3</span>Die vorstehend aufgeführten Fähigkeiten schließen z.B. die Fähigkeit zur
      Kontrolle der Daten und ihrer Verarbeitung ein, indem sichergestellt wird, dass die Partei sich bewusst ist
      über:
    </p>
    <ul class="terms-list">
      <li>
        die Herkunft der Daten (insbesondere, ob die Daten von der Partei selbst, einer anderen Partei oder
        einer Drittpartei stammen);
      </li>
      <li>die Rechtsgrundlage für die Verarbeitung der Daten;</li>
      <li>die für die Verarbeitung der Daten geltenden Beschränkungen und Bedingungen; und</li>
      <li>die Rechte und geltenden Beschränkungen für die Weiterverbreitung oder Aufbereitung von Daten.</li>
    </ul>
    <p class="terms-clause">
      <span class="terms-no">5.4</span>Die Parteien müssen außerdem in der Lage sein, Daten zu erkennen und sie zu
      löschen oder zurückzugeben, wenn die Rechtsgrundlage für die Verarbeitung der Daten entfällt. Die Pflicht
      zur Löschung oder Rückgabe von Daten gilt nicht für abgeleitetes Material.
    </p>
    <p class="terms-clause">
      <span class="terms-no">5.5</span>Alle festgestellten Datensicherheitsverstöße müssen ordnungsgemäß
      dokumentiert, behoben und den betroffenen Parteien unverzüglich gemeldet werden. Alle beteiligten Parteien
      tragen eine gemeinsame Verantwortung, in angemessenem Umfang zur Untersuchung von
      Datensicherheitsverstößen innerhalb des Datenraums beizutragen.
    </p>

    <h3 class="terms-h3">Subauftragnehmer</h3>
    <p class="terms-clause">
      <span class="terms-no">5.6</span>Die Parteien haben das Recht, Subauftragnehmer zur Erfüllung ihrer
      Verpflichtungen gemäß dem Gründungsvertrag einzusetzen. Soweit und in dem Umfang, in dem die ausgelagerten
      Funktionen es erfordern, können die Parteien ihren Subauftragnehmern den Zugang zu Daten gewähren. Die
      Parteien bleiben für die erbrachte Leistung der Subauftragnehmer verantwortlich, als wäre es ihre eigene.
    </p>
  </section>

  <section class="terms-section">
    <h2 class="terms-h2">6. Gebühren und Kosten</h2>
    <p class="terms-clause">
      <span class="terms-no">6.1</span>Daten werden innerhalb des Datenraums kostenlos genutzt, es sei denn, die
      geltenden Nutzungsbedingungen für Datensätze legen etwas anderes fest.
    </p>
    <p class="terms-clause">
      <span class="terms-no">6.2</span>Ungeachtet des Vorstehenden werden Daten stets kostenlos bereitgestellt,
      wenn dies durch den Data Act oder ein anderes geltendes Recht vorgeschrieben ist.
    </p>
    <p class="terms-clause">
      <span class="terms-no">6.3</span>Jede Partei trägt ihre eigenen Kosten, die mit dem Zugang zum Datenraum und
      der Teilnahme als Mitglied des Datenraums verbunden sind.
    </p>
    <p class="terms-clause">
      <span class="terms-no">6.4</span>Wenn die Parteien nichts anderes vereinbart haben, werden die gemeinsamen
      Kosten, die für die Unterhaltung und Verwaltung des Datenraums entstehen, den Parteien zu gleichen Anteilen
      zugewiesen. Zur Vermeidung von Zweifel, umfasst die Wartung und Verwaltung des Datenraums nicht die Kosten
      für Daten, soweit dies zutrifft und in den jeweiligen Nutzungsbedingungen für Datensätze festgelegt ist.
    </p>
  </section>

  <section class="terms-section">
    <h2 class="terms-h2">7. Geheimhaltung</h2>
    <p class="terms-clause">
      <span class="terms-no">7.1</span>Die Parteien dürfen jegliche vertraulichen Informationen, die sie im
      Zusammenhang mit dem Betrieb des Datenraums und/oder bezüglich des Datenraums erhalten, nur zu den Zwecken
      verwenden, für die solche vertraulichen Informationen bereitgestellt wurden. Die Parteien dürfen
      vertrauliche Informationen, von denen sie im Rahmen des Betriebs des Datenraums Kenntnis erlangt haben,
      nicht unrechtmäßig verwenden oder an Dritte weitergeben.
    </p>
    <p class="terms-clause">
      <span class="terms-no">7.2</span>Nach Ablauf oder Kündigung des Gründungsvertrags, müssen die Parteien die
      Nutzung vertraulicher Informationen einstellen und auf Aufforderung durch eine Partei Kopien davon
      nachweislich zurückgeben oder vernichten. Ungeachtet des Vorstehenden sind die Parteien berechtigt, die
      Daten vorbehaltlich der Klausel 10.2 weiter zu nutzen. Außerdem können die Parteien Kopien der vertraulichen
      Informationen behalten, wenn dies von geltendem Recht oder den zuständigen Behörden verlangt wird.
    </p>
    <p class="terms-clause">
      <span class="terms-no">7.3</span>Wenn eine Partei gemäß dem geltenden Recht oder einer Anordnung einer
      zuständigen Behörde verpflichtet ist, die vertraulichen Informationen einer anderen Partei an die Behörden
      oder Dritte offenzulegen, muss die verpflichtete Partei die betroffene Partei, deren vertrauliche
      Informationen offengelegt werden, unverzüglich benachrichtigen, sofern dies nach dem geltenden Recht oder
      der Anordnung der zuständigen Behörde zulässig ist.
    </p>
    <p class="terms-clause">
      <span class="terms-no">7.4</span>Die in diesen Allgemeinen Geschäftsbedingungen festgelegten
      Vertraulichkeitsverpflichtungen überdauern die Kündigung des Gründungsvertrags.
    </p>
  </section>

  <section class="terms-section">
    <h2 class="terms-h2">8. Immaterialgüterrechte</h2>
    <p class="terms-clause">
      <span class="terms-no">8.1</span>Die Immaterialgüterrechte der Parteien müssen im Zusammenhang mit dem
      Betrieb des Datenraums respektiert und geschützt werden.
    </p>
    <p class="terms-clause">
      <span class="terms-no">8.2</span>Das Unterzeichnen des Gründungsvertrags und das gemeinsame Nutzen von Daten
      innerhalb des Datenraums führen nicht zur Übertragung von Immaterialgüterrechten. Spezifischere
      Bestimmungen, sofern vorhanden, zu den Immaterialgüterrechten, die sich auf bestimmte Datensätze beziehen,
      sind in den geltenden Nutzungsbedingungen für Datensätze enthalten. Zur Vermeidung von Zweifeln gilt, dass
      alle neuen Immaterialgüterrechte, die von einer Partei geschaffen werden, bei der schaffenden Partei
      verbleiben, wie in der jeweils geltenden Gesetzgebung über Immaterialgüterrechte weiter definiert.
    </p>
    <p class="terms-clause">
      <span class="terms-no">8.3</span>Datenanbieter sind dafür verantwortlich sicherzustellen, dass sie
      ausreichende Rechte für die Bereitstellung von Daten gemäß den Nutzungsbedingungen für Datensätze haben.
    </p>
    <p class="terms-clause">
      <span class="terms-no">8.4</span>Die Parteien sind berechtigt, Software-Roboter oder andere Formen und
      Anwendungen der robotergestützten Prozessautomatisierung, maschinellen Lernens oder künstlichen Intelligenz
      bei der Datenverarbeitung einzusetzen. In Übereinstimmung mit dem Vorstehenden und den geltenden
      Nutzungsbedingungen für Datensätze haben die Parteien das Recht, aus den Daten zu lernen und alle fachlichen
      Fähigkeiten und Erfahrungen, die sie bei der Datenverarbeitung erwerben, zu nutzen.
    </p>
  </section>

  <section class="terms-section">
    <h2 class="terms-h2">9. Datenschutz</h2>
    <p class="terms-clause">
      <span class="terms-no">9.1</span>Jegliche personenbezogenen Daten, die im Datenraum verarbeitet werden,
      müssen gemäß den geltenden Datenschutzgesetzen und -bestimmungen verarbeitet werden.
    </p>
    <p class="terms-clause">
      <span class="terms-no">9.2</span>Begriffe, die hier nicht definiert werden, haben die Bedeutung gemäß der
      DSGVO oder sonstiger geltender Datenschutzgesetze.
    </p>
    <p class="terms-clause">
      <span class="terms-no">9.3</span>Für die Zwecke der Verarbeitung personenbezogener Daten innerhalb des
      Datenraums wird davon ausgegangen, dass alle Parteien, die Daten offenlegen oder empfangen, einzeln und
      getrennt als für die Verarbeitung Verantwortliche gemäß den Bestimmungen der DSGVO gelten. Von den besagten
      Parteien wird auch angenommen, dass sie die Daten in ihrem eigenen Namen verarbeiten, es sei denn, dass die
      Parteien einen schriftlichen Datenverarbeitungsvertrag abgeschlossen haben, der den Gegenstand und die
      Dauer der Verarbeitung, die Art und den Zweck der Verarbeitung, die Art der personenbezogenen Daten und die
      Kategorien von Betroffenen sowie die Rechte und Pflichten des Verantwortlichen und des Verarbeiters
      festlegen. Wenn ein solcher Datenverarbeitungsvertrag ganz allgemein für bestimmte Datensätze oder Services
      gilt, die im Rahmen des Gründungsvertrags bereitgestellt werden, muss er als Anhang in den Gründungsvertrag
      aufgenommen werden.
    </p>
    <p class="terms-clause">
      <span class="terms-no">9.4</span>Die Parteien müssen eine unbefugte und unrechtmäßige Verarbeitung
      personenbezogener Daten durch die Anwendung geeigneter technischer und organisatorischer Maßnahmen
      verhindern. Die Parteien müssen sicherstellen, dass Personen, die zur Verarbeitung personenbezogener Daten
      berechtigt sind, sich zur Vertraulichkeit dieser Daten verpflichtet haben oder durch eine angemessene
      gesetzliche Vertraulichkeitspflicht gebunden sind.
    </p>
    <p class="terms-clause">
      <span class="terms-no">9.5</span>Personenbezogene Daten, die innerhalb des Datenraums gemeinsam genutzt
      werden, können innerhalb der Europäischen Union und des Europäischen Wirtschaftsraums (EWR) übertragen
      werden. Diese Art von personenbezogenen Daten kann auch außerhalb der EU und des EWR im Einklang mit der
      geltenden Datenschutzgesetzgebung und Rechtsprechung übertragen werden, sofern nicht in den geltenden
      Nutzungsbedingungen für Datensätze etwas anderes festgelegt ist.
    </p>
    <p class="terms-clause">
      <span class="terms-no">9.6</span>Die Parteien verpflichten sich, den anderen Parteien angemessene Hilfe
      zukommen zu lassen, wenn solche Hilfe erforderlich ist, damit die andere Partei ihre Verpflichtungen gemäß
      der geltenden Datenschutzgesetzgebung einhalten kann.
    </p>
  </section>

  <section class="terms-section">
    <h2 class="terms-h2">10. Kündigung und Laufzeit</h2>
    <p class="terms-clause">
      <span class="terms-no">10.1</span>Wenn der Gründungsvertrag für einen bestimmten Zeitraum abgeschlossen wird,
      läuft er ohne separate Kündigung am Ende des betreffenden Zeitraums aus. Wenn der Gründungsvertrag für einen
      unbestimmten Zeitraum abgeschlossen wird, endet er bei einer Kündigung durch die Parteien.
    </p>
    <p class="terms-clause">
      <span class="terms-no">10.2</span>Die Parteien sind berechtigt, die Nutzung aller über den Datenraum vor der
      Kündigung des Gründungsvertrags erhaltenen Daten weiterhin zu nutzen, es sei denn, dass etwas anderes in den
      geltenden Nutzungsbedingungen für Datensätze festgelegt oder von den Parteien im Gründungsvertrag vereinbart
      wurde. In einem solchen Fall bleiben die Klauseln über die Nutzung von Daten in diesen Allgemeinen
      Geschäftsbedingungen, den Nutzungsbedingungen für Datensätze und/oder in dem Gründungsvertrag gemäß Klausel
      17.1 in Kraft.
    </p>
    <p class="terms-clause">
      <span class="terms-no">10.3</span>Jede Partei kann sich dafür entscheiden, den Gründungsvertrag zu kündigen,
      so wie dies im Gründungsvertrag festgelegt ist. Die Kündigung muss den Parteien des Gründungsvertrags
      schriftlich zugestellt werden. Wenn es mehr als zwei Parteien im Gründungsvertrag gibt, bleibt der
      Gründungsvertrag für die verbleibenden Parteien im Anschluss an die Kündigung durch eine Partei in Kraft.
    </p>
    <p class="terms-clause">
      <span class="terms-no">10.4</span>Wenn die Parteien einen Prozess für die Änderung des Gründungsvertrags auf
      andere Weise als durch die schriftliche Einwilligung aller Parteien vereinbart haben, hat jede Partei, die
      einen Einwand gegen eine solche Änderung erhebt, das Recht, den Gründungsvertrag durch schriftliche
      Mitteilung an die anderen Parteien zu kündigen, sobald sie von dieser Änderung erfährt. Die Kündigung wird
      wirksam, nachdem die widersprechende Partei die oben genannte Mitteilung an die anderen Parteien übermittelt
      hat, woraufhin die Änderung in Kraft tritt, es sei denn, die zustimmenden Parteien haben ein späteres Datum
      vereinbart.
    </p>
    <p class="terms-clause">
      <span class="terms-no">10.5</span>Falls es nur zwei Parteien im Gründungsvertrag gibt und eine der Parteien
      wesentlich gegen den Gründungsvertrag verstößt, hat die andere Partei das einseitige Recht, den
      Gründungsvertrag mit sofortiger Wirkung zu kündigen, indem sie der anderen Partei eine schriftliche
      Kündigung zustellt.
    </p>
    <p class="terms-clause">
      <span class="terms-no">10.6</span>Falls es mehr als zwei Parteien im Gründungsvertrag gibt, und eine Partei
      wesentlich gegen die Bestimmungen des Gründungsvertrags verstößt, hat der Lenkungsausschuss das Recht, der
      verstoßenden Partei den Gründungsvertrag mit sofortiger Wirkung zu kündigen. Die Mitteilung einer solchen
      Kündigung muss allen Parteien schriftlich zugestellt werden.
    </p>
    <p class="terms-clause">
      <span class="terms-no">10.7</span>Wenn der Verstoß korrigiert werden kann, kann/können die
      nicht-verstoßende/n Partei/Parteien beschließen, die Erfüllung ihrer Verpflichtungen im Rahmen des
      Gründungsvertrags auszusetzen, bis die verstoßende Partei den Verstoß behoben hat.
    </p>
    <p class="terms-clause">
      <span class="terms-no">10.8</span>Wenn die Mitgliedschaft eines Mitglieds des Datenraums infolge eines
      wesentlichen Verstoßes des Mitglieds gegen den Gründungsvertrag gekündigt wird, endet das Recht des
      Mitglieds zur Nutzung der Daten mit dem Datum der Kündigung. Das verstoßende Mitglied muss die Nutzung der
      Daten einstellen und auf Aufforderung durch eine Partei die Daten und alle Kopien vertraulicher
      Informationen nachweislich zurückgeben oder vernichten. Jedoch ist das verstoßende Mitglied berechtigt, die
      Daten in dem Maße zu behalten, als dies aufgrund geltenden Rechts oder zuständiger Behörden erforderlich
      ist, vorausgesetzt, dass das verstoßende Mitglied den Datenanbieter zum Datum der Kündigung über eine solche
      Verpflichtung zum Behalten der Daten unterrichtet.
    </p>
  </section>

  <section class="terms-section">
    <h2 class="terms-h2">11. Haftung</h2>
    <p class="terms-clause">
      <span class="terms-no">11.1</span>Die Parteien haften nur für direkte Schäden, die durch einen Verstoß gegen
      die Bestimmungen des Gründungsvertrags verursacht werden, so wie dies im Weiteren und gegebenenfalls im
      Gründungsvertrag definiert wird. Alle anderen Haftungen sind hiermit ausgeschlossen, es sei denn, etwas
      anderes wird ausdrücklich im Gründungsvertrag festgelegt. Die Parteien haften nicht für entgangenen Gewinn
      oder Schäden, die auf einen Rückgang oder eine Unterbrechung in der Produktion oder im Umsatz
      zurückzuführen sind, oder für sonstige indirekte oder Folgeschäden.<sup>1</sup>
    </p>
    <p class="terms-clause">
      <span class="terms-no">11.2</span>Die Parteien haften nicht für Verluste, Schäden, Kosten, Ansprüche oder
      Ausgaben, die auf eine mechanische oder elektrische Störung, einen Stromausfall oder eine andere Ursache
      zurückzuführen sind, die außerhalb der zumutbaren Kontrolle der Partei liegt; und die Parteien müssen alle
      Schäden, die auf einen absichtlichen oder grob fahrlässigen Verstoß gegen die Bestimmungen des
      Gründungsvertrags zurückzuführen sind, vollständig erstatten.
    </p>
    <p class="terms-clause">
      <span class="terms-no">11.3</span>Jede Partei haftet, einzeln und nicht gemeinsam, für Verstöße gegen die
      Verpflichtungen zu personenbezogenen Daten, die in der DSGVO festgelegt sind, gemäß Artikel 82 der DSGVO.
    </p>
    <p class="terms-footnote">
      <sup>1</sup> Die Parteien sollten beachten, dass das Konzept von indirekten oder Folgeschäden in den
      einzelnen Gerichtsbarkeiten unterschiedlich ist.
    </p>
  </section>

  <section class="terms-section">
    <h2 class="terms-h2">12. Höhere Gewalt</h2>
    <p class="terms-clause">
      <span class="terms-no">12.1</span>Keine Partei haftet für Verletzungen oder Schäden, die aus Ereignissen oder
      Umständen resultieren, die nicht vernünftigerweise im Voraus erwartet werden konnten und die außerhalb ihrer
      Kontrolle liegen (<em>höhere Gewalt</em>).
    </p>
    <p class="terms-clause">
      <span class="terms-no">12.2</span>Eine Partei, die aufgrund eines Ereignisses höherer Gewalt nicht in der
      Lage ist, ihren Verpflichtungen nachzukommen, muss die anderen Parteien unverzüglich über ein solches
      Hindernis unterrichten. Diese Gründe für die Nichterfüllung entfallen in dem Moment, in dem das Ereignis
      höherer Gewalt vorbei ist. Diese Klausel unterliegt einem Long-Stop-Datum: wenn die Erfüllung für einen
      kontinuierlichen Zeitraum von mehr als einhundertachtzig (180) Tagen oder mehr verhindert wird, sind die
      Parteien berechtigt, den Gründungsvertrag gemäß Klausel 10.5 oder 10.6 zu kündigen.
    </p>
  </section>

  <section class="terms-section">
    <h2 class="terms-h2">13. Audit</h2>
    <p class="terms-clause">
      <span class="terms-no">13.1</span>Ein Datenanbieter ist berechtigt, die Parteien, die die vom Datenanbieter
      zur Verfügung gestellten Daten verarbeiten, auf eigene Kosten zu überprüfen, einschließlich der materiellen
      und angemessenen direkten Kosten der geprüften Partei. Der Zweck und der Umfang des Audits beschränkt sich
      auf die Verifizierung der Einhaltung der wesentlichen Anforderungen des Gründungsvertrags, der geltenden
      Nutzungsbedingungen für Datensätze und der geltenden Gesetzgebung.
    </p>
    <p class="terms-clause">
      <span class="terms-no">13.2</span>Die Parteien sind dafür verantwortlich, dass die gleichen
      Audit-Verpflichtungen ihren verbundenen Unternehmen auferlegt werden, und die Parteien handeln in gutem
      Glauben um sicherzustellen, dass die Ziele der Auditrechte des Datenanbieters in Bezug auf die
      Subauftragnehmer einer Partei realisiert werden.
    </p>
    <p class="terms-clause">
      <span class="terms-no">13.3</span>Die auditierende Partei muss der geprüften Partei das Audit schriftlich
      mindestens dreißig (30) Tage im Voraus mitteilen. Die schriftliche Mitteilung muss den Umfang und die Dauer
      des Audits angeben und eine Liste der angeforderten Materialien und Zugangsrechte enthalten.
    </p>
    <p class="terms-clause">
      <span class="terms-no">13.4</span>Die geprüfte Partei ist berechtigt zu fordern, dass das Audit von einer
      für beide Seite akzeptable und/oder zertifizierten unabhängigen Drittpartei durchgeführt wird.
    </p>
    <p class="terms-clause">
      <span class="terms-no">13.5</span>Die Parteien sind verpflichtet, der prüfenden Partei und/oder dem
      Drittanbieter-Prüfer alle Aufzeichnungen und Dokumente sowie den Zugang zu allen erforderlichen
      Datensystemen und Räumlichkeiten und das Personal zu befragen zur Verfügung zu stellen, das für die Prüfung
      von wesentlicher Bedeutung ist. Aufzeichnungen und Dokumente, die so erhalten werden, müssen bis zu der
      vorherigen Prüfung oder den Beitritt der geprüften Partei zum Datenraum reichen, je nachdem, was der spätere
      Zeitpunkt ist.
    </p>
    <p class="terms-clause">
      <span class="terms-no">13.6</span>Die auditierende Partei und/oder der Drittpartei-Prüfer kann nur solche
      Aufzeichnungen und Dokumente und den Zugang zu solchen Datensystemen und Räumlichkeiten anfordern und solche
      Mitarbeiter befragen, die von erheblicher Bedeutung für das Audit sind.
    </p>
    <p class="terms-clause">
      <span class="terms-no">13.7</span>Alle im Laufe des Audits erfassten und offengelegten Aufzeichnungen,
      Dokumente und Informationen stellen vertrauliche Informationen dar. Die auditierende Partei und/oder der
      Drittpartei-Prüfer darf vertrauliche Informationen, von denen er im Laufe des Audits Kenntnis erhalten hat,
      nicht unrechtmäßig nutzen oder offenlegen. Die auditierende Partei hat zu gewährleisten, dass ein allfälliger
      Drittpartei-Prüfer die geltenden Geheimhaltungsverpflichtungen einhält. Die geprüfte Partei ist berechtigt,
      von der prüfenden Partei und/oder dem Drittanbieter-Prüfer oder anderen an der Prüfung beteiligten Personen
      zu verlangen, eine Geheimhaltungsvereinbarung zu unterzeichnen, vorausgesetzt die Bedingungen eines solchen
      Abkommens sind angemessen.
    </p>
    <p class="terms-clause">
      <span class="terms-no">13.8</span>Die Ergebnisse, Resultate und Empfehlungen des Audits sind in einem
      Auditbericht zu präsentieren. Die geprüfte Partei ist berechtigt, den Auditbericht eines Drittpartei-Prüfers
      im Voraus einzusehen (und bevor der Bericht dem/den betreffenden Datenanbieter(n) von dem Drittpartei-Prüfer
      bereitgestellt werden). Die geprüfte Partei ist berechtigt, vom Drittpartei-Prüfer zu verlangen, Änderungen
      am Prüfungsbericht vorzunehmen, die als angemessen erachtet werden, unter Berücksichtigung der vertraulichen
      Informationen der geprüften Partei und der geschäftlichen Interessen des Datenanbieters an den Daten. Die
      geprüfte Partei muss innerhalb von dreißig (30) Tagen auf den Auditbericht antworten. Wenn keine Antwort
      bereitgestellt wird, wird angenommen, dass die geprüfte Partei den Inhalt des Berichts akzeptiert hat.
    </p>
    <p class="terms-clause">
      <span class="terms-no">13.9</span>Wenn die auditierende Partei mit Recht der Ansicht ist, dass die geprüfte
      Partei einen wesentlichen Verstoß gegen ihre ihr im Gründungsvertrag auferlegten Verpflichtungen verstößt,
      kann ein zusätzliches Audit durchgeführt werden.
    </p>
    <p class="terms-clause">
      <span class="terms-no">13.10</span>Falls dieses Audit einen wesentlichen Verstoß gegen die im
      Gründungsvertrag auferlegten Verpflichtungen oder den geltenden Nutzungsbedingungen für Datensätze ergibt,
      haftet die geprüfte Partei für alle angemessenen und nachweislichen direkten Kosten, die infolge des Audits
      verursacht werden.
    </p>
  </section>

  <section class="terms-section">
    <h2 class="terms-h2">14. Anwendbares Recht und Streitbeilegung</h2>
    <p class="terms-clause">
      <span class="terms-no">14.1</span>Der Vertrag, der diesen Allgemeinen Geschäftsbedingungen unterliegt,
      unterliegen dem in der Gründungsvereinbarung festgelegten Recht und wird nach diesem ausgelegt.
    </p>
    <p class="terms-clause">
      <span class="terms-no">14.2</span>Alle Streitigkeiten, Meinungsverschiedenheiten oder Ansprüche, die sich aus
      oder im Zusammenhang mit den auf den Allgemeinen Geschäftsbedingungen basierenden Vereinbarungen oder deren
      Verletzung, Beendigung oder Gültigkeit ergeben, werden durch das in der Gründungsvereinbarung festgelegte
      Streitbeilegungsverfahren endgültig beigelegt.
    </p>
  </section>

  <section class="terms-section">
    <h2 class="terms-h2">15. Sonstige Bestimmungen</h2>
    <p class="terms-clause">
      <span class="terms-no">15.1</span>Wenn die Parteien nichts anderes vereinbart haben, müssen Änderungen am
      Gründungsvertrag und seinen Anhängen schriftlich abgefasst und von allen Parteien unterzeichnet werden.
    </p>
    <p class="terms-clause">
      <span class="terms-no">15.2</span>Keine Partei darf den Gründungsvertrag ganz oder teilweise ohne die
      schriftliche Zustimmung der anderen Partei/en abtreten. Ungeachtet des Vorstehenden ist keine Zustimmung
      erforderlich, wenn der Abtretungsempfänger ein Unternehmen ist, das der gleichen Unternehmensgruppe wie die
      Partei gemäß dem geltenden Recht angehört.
    </p>
    <p class="terms-clause">
      <span class="terms-no">15.3</span>Wenn eine der Bestimmungen dieser Geschäftsbedingungen, des
      Gründungsvertrags oder der geltenden Nutzungsbedingungen für Datensätze von einem Gericht oder einer anderen
      zuständigen Behörde für ungültig befunden wird, wirkt sich die Ungültigkeit dieser Bestimmung nicht auf die
      Gültigkeit der anderen Bestimmungen aus. In diesem Fall werden die Parteien bemüht sein, die ungültige
      Bestimmung durch eine gültige Bestimmung zu ersetzen, die dem wirtschaftlichen Zweck der ungültigen
      Bestimmung so weit wie möglich entspricht. Gleiches gilt für Vertragslücken.
    </p>
    <p class="terms-clause">
      <span class="terms-no">15.4</span>Jede Partei sichert zu und gewährleistet, dass sie gemäß den geltenden
      Gesetzen ihres Sitz- oder Registrierungslandes rechtswirksam besteht und zugelassen ist. Jede Partei sichert
      auch zu und gewährleistet, dass sie alle erforderliche Macht und Befugnis hat, ihre Verpflichtungen im
      Rahmen des Gründungsvertrags auszuführen, bereitzustellen und zu erfüllen und gegebenenfalls ihre
      verbundenen Unternehmen zu verpflichten.
    </p>
    <p class="terms-clause">
      <span class="terms-no">15.5</span>Die Parteien beabsichtigen die Gründung eines Datenraumes, das einem
      einzigen Satz Vertragsbedingungen unterliegt, und nichts in diesem Gründungsvertrag kann so ausgelegt
      werden, dass sie Partner oder Parteien eines Joint-Ventures oder die Auftraggeber, Vertreter oder
      Mitarbeiter der anderen Parteien sind. Keine Partei hat das Recht, die Macht oder die Befugnis, ausdrücklich
      oder impliziert, eine andere Partei zu verpflichten.
    </p>
    <p class="terms-clause">
      <span class="terms-no">15.6</span>Keine Verzögerung oder Unterlassung durch eine Partei dieses Vertrags bei
      der Ausübung eines Rechts oder einer Befugnis im Rahmen dieses Vertrags beeinträchtigt ein solches Recht
      oder eine solche Befugnis, noch kann dies als ein Verzicht darauf ausgelegt werden. Ein Verzicht einer der
      Parteien auf eine Ausführung einer der Vereinbarungen durch die anderen Parteien oder bei einem Verstoß
      dagegen, kann nicht als Verzicht im Fall eines weiteren Verstoßes gegen diese oder eine andere Vereinbarung
      ausgelegt werden.
    </p>
  </section>

  <section class="terms-section">
    <h2 class="terms-h2">16. Mitteilungen</h2>
    <p class="terms-clause">
      <span class="terms-no">16.1</span>Alle Mitteilungen im Zusammenhang mit diesen Allgemeinen
      Geschäftsbedingungen und dem Gründungsvertrag müssen der von der jeweiligen Partei im Gründungsvertrag oder
      in der betreffenden Beitrittsvereinbarung angegebenen Kontaktperson und/oder Adresse in schriftlicher oder
      elektronischer Form (einschließlich per Post oder E-Mail) geschickt oder persönlich zugestellt werden.
      Mitteilungen gelten innerhalb von drei (3) Tagen, nachdem sie verschickt wurden, oder gemäß
      Zustellungsnachweis als zugestellt.
    </p>
  </section>

  <section class="terms-section">
    <h2 class="terms-h2">17. Fortbestand</h2>
    <p class="terms-clause">
      <span class="terms-no">17.1</span>Die Klauseln 1, 2, 3, 4, 5, 8, 9, 11, 14, 16 und 17 dieser Allgemeinen
      Geschäftsbedingungen überdauern die Kündigung des Gründungsvertrags in seiner Gesamtheit zusammen mit allen
      Klauseln des Gründungsvertrag, die logischerweise auch nach der Kündigung fortbestehen sollten.
    </p>
    <p class="terms-clause">
      <span class="terms-no">17.2</span>Klausel 13 dieser Allgemeinen Geschäftsbedingungen besteht für einen
      Zeitraum von drei (3) Jahren im Anschluss an die Kündigung des Gründungsvertrags in seiner Gesamtheit fort.
    </p>
    <p class="terms-clause">
      <span class="terms-no">17.3</span>Klausel 7 dieser Allgemeinen Geschäftsbedingungen besteht für einen
      Zeitraum von fünf (5) Jahren im Anschluss an die Kündigung des Gründungsvertrags in seiner Gesamtheit fort.
    </p>
  </section>

  <p class="terms-stand"><strong>HT-X AGB (Sitra Rulebook 3.0 Template) — Version 1.0, Juni 2025</strong></p>
</article>
